<template>
  <div class="size-full overflow-hidden rounded-xl">
    <img v-lazy-load :src="logo" class="size-full object-contain" />
  </div>
</template>

<script setup>
defineProps({
  logo: {
    type: String,
    required: true,
  },
});
</script>

<style scoped lang="scss"></style>
